import React, { Component } from 'react';
import PropTypes from 'prop-types';

import axios from '../../../axios/axios';
import CarouselPartnerItem from './../main/CarouselPartnerItem';
import Loader from '../../components/loader/loader';
import { translateStaticContent } from '../../../helpers/translateStaticContent';

class PartnersSection extends Component {
    constructor(props) {
        super(props);
        this.props = props;

        this.state = {
            partner: [],
            position: 0,
            count: 1,
            loading: false
        }
    }

    componentDidMount() {
        this.setState({...this.state, loading: true }, () => {
            this.setCount();
            axios.get(`/api/welsend/public/partners`)
            .then(res => {
                this.getPartnersList(res.data);
            })
            .catch((error =>  {
                console.log(error);
            }))
        })
    }

    setCount = () => {
        let sizeWidth = document.documentElement.scrollWidth;
        if (sizeWidth <= 768) {
            this.setState({...this.state, count: 1});
        } else if (sizeWidth > 768 && sizeWidth <= 960) {
            this.setState({...this.state, count: 2});
        } else if (sizeWidth > 960 && sizeWidth <= 1200) {
            this.setState({...this.state, count: 3}); 
        } else if (sizeWidth > 1290) {
            this.setState({...this.state, count: 5});
        }
    }

    getPartnersList = (data) => {
        const list = data.map(item => {
            return <CarouselPartnerItem data={item} key={item.id}/>
        })
        this.setState({...this.state, partner: list, loading: false})
    } 

    handleRightButton = () => {
       const partnerslist = document.getElementById('partners-list');
       let position = this.state.position;
       let width = 226;
       let count = this.state.count;
       let length = this.state.partner.length;
       position -= width * count;
       position = Math.max(position, -width * (length - count));
       this.setState({...this.state, position})
       partnerslist.style.marginLeft = position + 'px';
    }

    handleLeftButton = () => {
        let position = this.state.position;
        let width = 226;
        let count = this.state.count;
        position += width * count;
        position = Math.min(position, 0);
        this.setState({...this.state, position});
        const partnerslist = document.getElementById('partners-list');
        partnerslist.style.marginLeft = position + 'px';
    }

    render() {
     return(
        <div className="container partnersSection">
            <h2>
                {translateStaticContent('partnersHeading', 
                    this.props.defaultStaticContentPartners, this.props.activeLangStaticContentPartners)}
            </h2>
            {this.state.loading ? <Loader /> :
            <div className="carousel-wrapper">
                <button className="left" onClick={this.handleLeftButton}></button>
                    <div className="carousel">
                        <div className="partners-list" id='partners-list'>
                            {this.state.partner.length > 0 ? this.state.partner : ''}
                        </div>
                    </div>
                <button className="right" onClick={this.handleRightButton}></button>
             </div>
            }
        </div>
       
        )
    }
}

export default PartnersSection;

PartnersSection.propTypes = {
    defaultStaticContentPartners: PropTypes.object,
    activeLangStaticContentPartners: PropTypes.object,
}